import React, { Component } from 'react'
import { env_url, sn_url } from '../../utils/js/endpoints'
import { fireAnalytics } from 'utils/js/analytic_helpers'

import './RadioStations.scss'

class RadioStations extends Component {
    render() {
        return (
            <div className="RadioStations__cont">
                <div className="schedule_link">
                    <a
                        href="https://www.sportsnet.ca/schedule/radio/"
                        onClick={() => {
                            fireAnalytics(
                                'radio schedule',
                                'Radio Stations',
                                2,
                                `${sn_url}/schedule/radio/`,
                                'View Radio Schedule',
                                'ANALYTIC_EVENT_BROADCAST_SCHEDULE'
                            )
                        }}
                    >
                        View Radio Schedule
                    </a>
                </div>
                <div className="logos_cont">
                    <img src={`${env_url}/sn590.png`} alt="" />
                    <img src={`${env_url}/sn960.png`} alt="" />
                    <img src={`${env_url}/sn650.png`} alt="" />
                </div>
            </div>
        )
    }
}

export default RadioStations
